module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/gallery/gallery11-f7a814794d36671c8a876b7876cd506b.jpg";